import React, { useCallback, useMemo } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import {
  useCurrentDiagnosis,
  useDiagnosesActions,
  useAlerts,
  GENERATE_PRESCRIPTION,
  ID,
  PRESCRIPTION_COMMENT,
} from 'store/diagnoses';
import FormContainer from 'components/FormContainer';

import { getInitValues } from './utils';
import CreationForm from './CreationForm';
import MedicationsForm from './MedicationsForm';
import CommentForm from './CommentForm';

export default function RecipeForm({ readMode }) {
  const diagnosis = useCurrentDiagnosis();
  const { saveDiagnosis } = useDiagnosesActions();
  const { action: save } = useAlerts(saveDiagnosis);
  const initialValues = useMemo(() => getInitValues(diagnosis), [diagnosis]);
  const sendData = useCallback(
    (values) => {
      save({
        diagnosisId: diagnosis[ID],
        [GENERATE_PRESCRIPTION]: values[GENERATE_PRESCRIPTION],
        [PRESCRIPTION_COMMENT]: values[PRESCRIPTION_COMMENT],
      });
    },
    [diagnosis, save]
  );

  return (
    <Formik initialValues={initialValues} validate={sendData} validateOnBlur={false}>
      <FormContainer>
        <CreationForm readMode={readMode} />
        <MedicationsForm readMode={readMode} />
        {Boolean(diagnosis[GENERATE_PRESCRIPTION]) && <CommentForm readMode={readMode} />}
      </FormContainer>
    </Formik>
  );
}

RecipeForm.propTypes = { readMode: PropTypes.bool.isRequired };
